import type { AppLocale, Messages } from "./types";

/** `getMessages` içinde `TRANSLATIONS` üzerine birleştirilir — yalnızca hava anahtarları. */
export const WEATHER_I18N: Record<AppLocale, Partial<Messages>> = {
  en: {},
  tr: {
    weatherTitle: "Hava",
    weatherForecastTooFar: "Günlük tahmin düğüne iki hafta kala burada görünecek.",
    weatherPastEvent: "Bu etkinlik tarihi geçti; tahmin gösterilmiyor.",
    weatherLoadError: "Hava yüklenemedi. Daha sonra deneyin.",
    weatherNoData: "Bu gün için henüz tahmin yok.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Tören saatinde ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Yağış olasılığı: {pct}%",
    weatherAriaTempCelsius: "Sıcaklığı Santigrat göster",
    weatherAriaTempFahrenheit: "Sıcaklığı Fahrenheit göster",
    weatherClear: "Açık",
    weatherCloudy: "Bulutlu",
    weatherFog: "Sis",
    weatherDrizzle: "Çisenti",
    weatherRain: "Yağmurlu",
    weatherSnow: "Karlı",
    weatherRainShowers: "Sağanak yağmur",
    weatherSnowShowers: "Kar sağanağı",
    weatherThunderstorm: "Fırtına",
    weatherUnknown: "Değişken",
  },
  ar: {
    weatherTitle: "الطقس",
    weatherForecastTooFar: "سيظهر الطقس اليومي هنا قبل أسبوعين من الزفاف.",
    weatherPastEvent: "تاريخ المناسبة مضى — لا يُعرض الطقس.",
    weatherLoadError: "تعذّر تحميل الطقس. حاول لاحقًا.",
    weatherNoData: "لا توجد بيانات لهذا اليوم بعد.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°م",
    weatherUnitFahrenheit: "°ف",
    weatherCeremonyLine: "في وقت الحفل ({time}): {temp}، {summary}.",
    weatherRainChanceDay: "احتمال المطر: {pct}٪",
    weatherAriaTempCelsius: "عرض الحرارة بالمئوية",
    weatherAriaTempFahrenheit: "عرض الحرارة بالفهرنهايت",
    weatherClear: "صافٍ",
    weatherCloudy: "غائم",
    weatherFog: "ضباب",
    weatherDrizzle: "رذاذ",
    weatherRain: "ممطر",
    weatherSnow: "ثلج",
    weatherRainShowers: "زخات مطر",
    weatherSnowShowers: "زخات ثلج",
    weatherThunderstorm: "عاصفة رعدية",
    weatherUnknown: "أجواء متفاوتة",
  },
  "zh-Hans": {
    weatherTitle: "天气",
    weatherForecastTooFar: "每日预报将在婚礼前两周于此显示。",
    weatherPastEvent: "该日期已过，不显示预报。",
    weatherLoadError: "无法加载天气，请稍后重试。",
    weatherNoData: "尚无该日预报。",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "仪式时间（{time}）：{temp}，{summary}。",
    weatherRainChanceDay: "降雨概率：{pct}%",
    weatherAriaTempCelsius: "使用摄氏温度",
    weatherAriaTempFahrenheit: "使用华氏温度",
    weatherClear: "晴",
    weatherCloudy: "多云",
    weatherFog: "雾",
    weatherDrizzle: "毛毛雨",
    weatherRain: "雨",
    weatherSnow: "雪",
    weatherRainShowers: "阵雨",
    weatherSnowShowers: "阵雪",
    weatherThunderstorm: "雷暴",
    weatherUnknown: "多变",
  },
  da: {
    weatherTitle: "Vejret",
    weatherForecastTooFar: "Daglig prognose vises her to uger før brylluppet.",
    weatherPastEvent: "Denne dato er passeret — ingen prognose.",
    weatherLoadError: "Vejret kunne ikke indlæses. Prøv senere.",
    weatherNoData: "Ingen prognose for denne dag endnu.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Ved ceremonitid ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Chance for regn: {pct} %",
    weatherAriaTempCelsius: "Vis temperatur i Celsius",
    weatherAriaTempFahrenheit: "Vis temperatur i Fahrenheit",
    weatherClear: "Klart",
    weatherCloudy: "Overskyet",
    weatherFog: "Tåge",
    weatherDrizzle: "Støvregn",
    weatherRain: "Regn",
    weatherSnow: "Sne",
    weatherRainShowers: "Byger",
    weatherSnowShowers: "Snebyger",
    weatherThunderstorm: "Tordenvejr",
    weatherUnknown: "Skiftende",
  },
  nl: {
    weatherTitle: "Weer",
    weatherForecastTooFar: "De dagelijkse voorspelling verschijnt hier twee weken voor de bruiloft.",
    weatherPastEvent: "Deze datum is voorbij — geen voorspelling.",
    weatherLoadError: "Weer laden mislukt. Probeer later opnieuw.",
    weatherNoData: "Nog geen voorspelling voor deze dag.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Rond de ceremonie ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Kans op regen: {pct}%",
    weatherAriaTempCelsius: "Temperatuur in Celsius tonen",
    weatherAriaTempFahrenheit: "Temperatuur in Fahrenheit tonen",
    weatherClear: "Helder",
    weatherCloudy: "Bewolkt",
    weatherFog: "Mist",
    weatherDrizzle: "Motregen",
    weatherRain: "Regen",
    weatherSnow: "Sneeuw",
    weatherRainShowers: "Buien",
    weatherSnowShowers: "Sneeuwbuien",
    weatherThunderstorm: "Onweer",
    weatherUnknown: "Wisselvallig",
  },
  fr: {
    weatherTitle: "Météo",
    weatherForecastTooFar:
      "La prévision quotidienne s’affichera ici deux semaines avant le mariage.",
    weatherPastEvent: "Cette date est passée — pas de prévision.",
    weatherLoadError: "Impossible de charger la météo. Réessayez plus tard.",
    weatherNoData: "Pas encore de prévision pour ce jour.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "À l’heure de la cérémonie ({time}) : {temp}, {summary}.",
    weatherRainChanceDay: "Risque de pluie : {pct} %",
    weatherAriaTempCelsius: "Afficher les températures en Celsius",
    weatherAriaTempFahrenheit: "Afficher les températures en Fahrenheit",
    weatherClear: "Dégagé",
    weatherCloudy: "Nuageux",
    weatherFog: "Brouillard",
    weatherDrizzle: "Bruine",
    weatherRain: "Pluie",
    weatherSnow: "Neige",
    weatherRainShowers: "Averses",
    weatherSnowShowers: "Averses de neige",
    weatherThunderstorm: "Orage",
    weatherUnknown: "Conditions variables",
  },
  de: {
    weatherTitle: "Wetter",
    weatherForecastTooFar: "Die Tagesvorhersage erscheint hier zwei Wochen vor der Hochzeit.",
    weatherPastEvent: "Dieses Datum liegt in der Vergangenheit — keine Vorhersage.",
    weatherLoadError: "Wetter konnte nicht geladen werden. Bitte später erneut versuchen.",
    weatherNoData: "Für diesen Tag liegt noch keine Vorhersage vor.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Zur Zeremoniezeit ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Regenwahrscheinlichkeit: {pct} %",
    weatherAriaTempCelsius: "Temperaturen in Celsius anzeigen",
    weatherAriaTempFahrenheit: "Temperaturen in Fahrenheit anzeigen",
    weatherClear: "Klar",
    weatherCloudy: "Bewölkt",
    weatherFog: "Nebel",
    weatherDrizzle: "Nieselregen",
    weatherRain: "Regen",
    weatherSnow: "Schnee",
    weatherRainShowers: "Regenschauer",
    weatherSnowShowers: "Schneeschauer",
    weatherThunderstorm: "Gewitter",
    weatherUnknown: "Wechselhaft",
  },
  he: {
    weatherTitle: "מזג אוויר",
    weatherForecastTooFar: "התחזית היומית תופיע כאן שבועיים לפני החתונה.",
    weatherPastEvent: "התאריך עבר — אין תחזית.",
    weatherLoadError: "לא ניתן לטעון מזג אוויר. נסו שוב מאוחר יותר.",
    weatherNoData: "אין עדיין תחזית ליום זה.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "בשעת הטקס ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "סיכוי לגשם: {pct}%",
    weatherAriaTempCelsius: "הצג טמפרטורה בצלזיוס",
    weatherAriaTempFahrenheit: "הצג טמפרטורה בפרנהייט",
    weatherClear: "בהיר",
    weatherCloudy: "מעונן",
    weatherFog: "ערפל",
    weatherDrizzle: "טפטוף",
    weatherRain: "גשם",
    weatherSnow: "שלג",
    weatherRainShowers: "ממטרים",
    weatherSnowShowers: "ממטרי שלג",
    weatherThunderstorm: "סופת רעמים",
    weatherUnknown: "משתנה",
  },
  hi: {
    weatherTitle: "मौसम",
    weatherForecastTooFar: "दैनिक पूर्वानुमान शादी से दो सप्ताह पहले यहाँ दिखाई देगा।",
    weatherPastEvent: "यह तारीख बीत चुकी है — कोई पूर्वानुमान नहीं।",
    weatherLoadError: "मौसम लोड नहीं हो सका। बाद में कोशिश करें।",
    weatherNoData: "इस दिन का अभी कोई पूर्वानुमान नहीं।",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "समारोह के समय ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "बारिश की संभावना: {pct}%",
    weatherAriaTempCelsius: "तापमान सेल्सियस में दिखाएँ",
    weatherAriaTempFahrenheit: "तापमान फ़ारेनहाइट में दिखाएँ",
    weatherClear: "साफ़",
    weatherCloudy: "बादल",
    weatherFog: "कोहरा",
    weatherDrizzle: "बूंदाबांदी",
    weatherRain: "बारिश",
    weatherSnow: "बर्फ़",
    weatherRainShowers: "मूसलाधार बारिश",
    weatherSnowShowers: "हिम वर्षा",
    weatherThunderstorm: "आंधी-तूफ़ान",
    weatherUnknown: "मिश्रित",
  },
  id: {
    weatherTitle: "Cuaca",
    weatherForecastTooFar: "Prakiraan harian akan muncul di sini dua minggu sebelum pernikahan.",
    weatherPastEvent: "Tanggal ini sudah lewat — tidak ditampilkan.",
    weatherLoadError: "Cuaca tidak dapat dimuat. Coba lagi nanti.",
    weatherNoData: "Belum ada prakiraan untuk hari ini.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Pada waktu upacara ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Peluang hujan: {pct}%",
    weatherAriaTempCelsius: "Tampilkan suhu dalam Celsius",
    weatherAriaTempFahrenheit: "Tampilkan suhu dalam Fahrenheit",
    weatherClear: "Cerah",
    weatherCloudy: "Berawan",
    weatherFog: "Kabut",
    weatherDrizzle: "Gerimis",
    weatherRain: "Hujan",
    weatherSnow: "Salju",
    weatherRainShowers: "Hujan lebat",
    weatherSnowShowers: "Hujan salju",
    weatherThunderstorm: "Badai petir",
    weatherUnknown: "Berubah-ubah",
  },
  it: {
    weatherTitle: "Meteo",
    weatherForecastTooFar:
      "La previsione giornaliera comparirà qui due settimane prima del matrimonio.",
    weatherPastEvent: "Questa data è passata — nessuna previsione.",
    weatherLoadError: "Impossibile caricare il meteo. Riprova più tardi.",
    weatherNoData: "Nessuna previsione per questo giorno.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "All’ora della cerimonia ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Probabilità di pioggia: {pct}%",
    weatherAriaTempCelsius: "Mostra le temperature in Celsius",
    weatherAriaTempFahrenheit: "Mostra le temperature in Fahrenheit",
    weatherClear: "Sereno",
    weatherCloudy: "Nuvoloso",
    weatherFog: "Nebbia",
    weatherDrizzle: "Pioggerella",
    weatherRain: "Pioggia",
    weatherSnow: "Neve",
    weatherRainShowers: "Rovesci",
    weatherSnowShowers: "Rovesci di neve",
    weatherThunderstorm: "Temporale",
    weatherUnknown: "Condizioni variabili",
  },
  ja: {
    weatherTitle: "天気",
    weatherForecastTooFar: "日ごとの予報は、結婚式の2週間前にここに表示されます。",
    weatherPastEvent: "この日付は過ぎています。表示しません。",
    weatherLoadError: "天気を読み込めませんでした。後でもう一度お試しください。",
    weatherNoData: "この日の予報はまだありません。",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "式の時間（{time}）: {temp}、{summary}。",
    weatherRainChanceDay: "降水確率: {pct}%",
    weatherAriaTempCelsius: "摂氏で気温を表示",
    weatherAriaTempFahrenheit: "華氏で気温を表示",
    weatherClear: "晴れ",
    weatherCloudy: "くもり",
    weatherFog: "霧",
    weatherDrizzle: "霧雨",
    weatherRain: "雨",
    weatherSnow: "雪",
    weatherRainShowers: "にわか雨",
    weatherSnowShowers: "にわか雪",
    weatherThunderstorm: "雷雨",
    weatherUnknown: "くもりがち",
  },
  no: {
    weatherTitle: "Vær",
    weatherForecastTooFar: "Daglig varsel vises her to uker før bryllupet.",
    weatherPastEvent: "Denne datoen er passert — ingen varsel.",
    weatherLoadError: "Kunne ikke laste vær. Prøv igjen senere.",
    weatherNoData: "Ingen varsel for denne dagen ennå.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Ved seremonitid ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Sjanse for regn: {pct} %",
    weatherAriaTempCelsius: "Vis temperatur i Celsius",
    weatherAriaTempFahrenheit: "Vis temperatur i Fahrenheit",
    weatherClear: "Klart",
    weatherCloudy: "Overskyet",
    weatherFog: "Tåke",
    weatherDrizzle: "Yr",
    weatherRain: "Regn",
    weatherSnow: "Snø",
    weatherRainShowers: "Regnbyger",
    weatherSnowShowers: "Snøbyger",
    weatherThunderstorm: "Tordenvær",
    weatherUnknown: "Skiftende",
  },
  "pt-PT": {
    weatherTitle: "Meteorologia",
    weatherForecastTooFar: "A previsão diária aparecerá aqui duas semanas antes do casamento.",
    weatherPastEvent: "Esta data já passou — sem previsão.",
    weatherLoadError: "Não foi possível carregar a meteorologia. Tente mais tarde.",
    weatherNoData: "Ainda não há previsão para este dia.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "À hora da cerimónia ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Probabilidade de chuva: {pct}%",
    weatherAriaTempCelsius: "Mostrar temperatura em Celsius",
    weatherAriaTempFahrenheit: "Mostrar temperatura em Fahrenheit",
    weatherClear: "Limpo",
    weatherCloudy: "Nublado",
    weatherFog: "Nevoeiro",
    weatherDrizzle: "Chuvisco",
    weatherRain: "Chuva",
    weatherSnow: "Neve",
    weatherRainShowers: "Aguaceiros",
    weatherSnowShowers: "Aguaceiros de neve",
    weatherThunderstorm: "Trovoada",
    weatherUnknown: "Condições mistas",
  },
  ru: {
    weatherTitle: "Погода",
    weatherForecastTooFar: "Ежедневный прогноз появится здесь за две недели до свадьбы.",
    weatherPastEvent: "Дата прошла — прогноз не показывается.",
    weatherLoadError: "Не удалось загрузить погоду. Попробуйте позже.",
    weatherNoData: "Пока нет прогноза на этот день.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Ко времени церемонии ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Вероятность дождя: {pct}%",
    weatherAriaTempCelsius: "Показывать температуру по Цельсию",
    weatherAriaTempFahrenheit: "Показывать температуру по Фаренгейту",
    weatherClear: "Ясно",
    weatherCloudy: "Облачно",
    weatherFog: "Туман",
    weatherDrizzle: "Морось",
    weatherRain: "Дождь",
    weatherSnow: "Снег",
    weatherRainShowers: "Ливни",
    weatherSnowShowers: "Снегопады",
    weatherThunderstorm: "Гроза",
    weatherUnknown: "Переменная облачность",
  },
  sk: {
    weatherTitle: "Počasie",
    weatherForecastTooFar: "Denná predpoveď sa zobrazí tu dva týždne pred svadbou.",
    weatherPastEvent: "Tento dátum už prešiel — žiadna predpoveď.",
    weatherLoadError: "Počasie sa nepodarilo načítať. Skúste neskôr.",
    weatherNoData: "Pre tento deň zatiaľ nie je predpoveď.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "V čase obradu ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Pravdepodobnosť dažďa: {pct} %",
    weatherAriaTempCelsius: "Zobraziť teplotu v stupňoch Celzia",
    weatherAriaTempFahrenheit: "Zobraziť teplotu v stupňoch Fahrenheita",
    weatherClear: "Jasno",
    weatherCloudy: "Oblačno",
    weatherFog: "Hmla",
    weatherDrizzle: "Mrholenie",
    weatherRain: "Dážď",
    weatherSnow: "Sneh",
    weatherRainShowers: "Prehánky",
    weatherSnowShowers: "Snehové prehánky",
    weatherThunderstorm: "Búrka",
    weatherUnknown: "Premenlivé",
  },
  es: {
    weatherTitle: "Tiempo",
    weatherForecastTooFar: "La previsión diaria aparecerá aquí dos semanas antes de la boda.",
    weatherPastEvent: "Esta fecha ya pasó — no se muestra el tiempo.",
    weatherLoadError: "No se pudo cargar el tiempo. Inténtalo más tarde.",
    weatherNoData: "Aún no hay previsión para este día.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "A la hora de la ceremonia ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Probabilidad de lluvia: {pct} %",
    weatherAriaTempCelsius: "Mostrar temperatura en Celsius",
    weatherAriaTempFahrenheit: "Mostrar temperatura en Fahrenheit",
    weatherClear: "Despejado",
    weatherCloudy: "Nuboso",
    weatherFog: "Niebla",
    weatherDrizzle: "Llovizna",
    weatherRain: "Lluvia",
    weatherSnow: "Nieve",
    weatherRainShowers: "Chubascos",
    weatherSnowShowers: "Chubascos de nieve",
    weatherThunderstorm: "Tormenta",
    weatherUnknown: "Condiciones mixtas",
  },
  uk: {
    weatherTitle: "Погода",
    weatherForecastTooFar: "Щоденний прогноз з’явиться тут за два тижні до весілля.",
    weatherPastEvent: "Дата минула — прогноз не показується.",
    weatherLoadError: "Не вдалося завантажити погоду. Спробуйте пізніше.",
    weatherNoData: "Поки немає прогнозу на цей день.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "На час церемонії ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Ймовірність дощу: {pct}%",
    weatherAriaTempCelsius: "Показувати температуру за Цельсієм",
    weatherAriaTempFahrenheit: "Показувати температуру за Фаренгейтом",
    weatherClear: "Ясно",
    weatherCloudy: "Хмарно",
    weatherFog: "Туман",
    weatherDrizzle: "Морось",
    weatherRain: "Дощ",
    weatherSnow: "Сніг",
    weatherRainShowers: "Зливи",
    weatherSnowShowers: "Снігопади",
    weatherThunderstorm: "Гроза",
    weatherUnknown: "Мінлива хмарність",
  },
  vi: {
    weatherTitle: "Thời tiết",
    weatherForecastTooFar: "Dự báo theo ngày sẽ hiển thị tại đây hai tuần trước đám cưới.",
    weatherPastEvent: "Ngày này đã qua — không hiển thị dự báo.",
    weatherLoadError: "Không tải được thời tiết. Thử lại sau.",
    weatherNoData: "Chưa có dự báo cho ngày này.",
    weatherTempRange: "{min}° / {max}°",
    weatherUnitCelsius: "°C",
    weatherUnitFahrenheit: "°F",
    weatherCeremonyLine: "Vào giờ lễ ({time}): {temp}, {summary}.",
    weatherRainChanceDay: "Khả năng mưa: {pct}%",
    weatherAriaTempCelsius: "Hiển thị nhiệt độ theo Celsius",
    weatherAriaTempFahrenheit: "Hiển thị nhiệt độ theo Fahrenheit",
    weatherClear: "Trời quang",
    weatherCloudy: "Nhiều mây",
    weatherFog: "Sương mù",
    weatherDrizzle: "Mưa phùn",
    weatherRain: "Mưa",
    weatherSnow: "Tuyết",
    weatherRainShowers: "Mưa rào",
    weatherSnowShowers: "Tuyết rào",
    weatherThunderstorm: "Dông",
    weatherUnknown: "Thất thường",
  },
};
